import AssessoriaFollowupPage from '../../pages/assessoria/assessoriaFollowupPage/assessoriaFollowupPage';
import FollowUpAssessoriaTimelineManagerPage from '../../pages/assessoria/assessoriaFollowupTimelineManagerPage/assessoriaFollowUpTimelineManagePage';
import AssessoriaPage from '../../pages/assessoria/assessoriaPage';
import NewAssessoriaFollowupPage from '../../pages/assessoria/newAssessoriaFollowupPage/newAssessoriaFollowupPage';
import ViewAssessoriaFollowupPage from '../../pages/assessoria/viewAssessoriaFollowupPage/viewAssessoriaFollowupPage';
import ComercialPage from '../../pages/comercial/comercialPage';
import PropostasCadastros from '../../pages/comercial/propostas/propostasCadastrosPage/propostasCadastros';
import PropostasDetails from '../../pages/comercial/propostas/propostasDetails/propostasDetails';
import PropostasFollowUpPage from '../../pages/comercial/propostas/propostasFollowUpPage/propostasFollowUpPage';
import PropostasIndices from '../../pages/comercial/propostas/propostasIndicesPage/propostasIndices';
import PropostasMercadorias from '../../pages/comercial/propostas/propostasMercadoria/propostasMercadorias';
import PropostasNewPage from '../../pages/comercial/propostas/propostasNewPage/propostasNewPage';
import PropostasPage from '../../pages/comercial/propostas/propostasPage';
import PropostasServicos from '../../pages/comercial/propostas/propostasServicosPage/propostasServicos';
import IntegracaoPage from '../../pages/integracao/integracaoPage';
import PlanilhasPage from '../../pages/integracao/planilhas/PlanilhasPage';
import FaturasPlanilhasPage from '../../pages/integracao/planilhas/faturas/faturaPlanilhasPage';
import EmpresasEstrangeirasPlanilhasPage from '../../pages/integracao/planilhas/EmpresaEstrangeiras/empresasEstrangeirasPlanilhasPage';
import TotvsEscritaDanfePage from '../../pages/integracao/totvs-easy/escrita/danfe/totvsEscritaDanfePage';
import TotvsEscritaDespesasPage from '../../pages/integracao/totvs-easy/escrita/despesas/totvsEscritaDespesasPage';
import TotvsEscritaNumerariosPage from '../../pages/integracao/totvs-easy/escrita/numerarios/totvsEscritaNumerariosPage';
import TotvsEscritaPage from '../../pages/integracao/totvs-easy/escrita/totvsEscritaPage';
import TotvsLeituraPage from '../../pages/integracao/totvs-easy/leitura/totvsLeituraPage';
import TotvsCorrespondenciaDetailsPage from '../../pages/integracao/totvs-easy/totvsCorrespondenciaDetailsPage';
import TotvsCorrespondenciaPage from '../../pages/integracao/totvs-easy/totvsCorrespondenciaPage';
import TotuvseasyPage from '../../pages/integracao/totvs-easy/totvseasyPage';
import RelatorioAssociatedPage from '../../pages/relatorios/relatorioAssociated/relatorioAssociatedPage';
import RelatorioDraftDanfePage from '../../pages/relatorios/relatorioDraftDanfe/relatorioDraftDanfePage';
import RelatorioDraftDanfeFaxePage from '../../pages/relatorios/relatorioDraftDanfeFaxe/relatorioDraftDanfeFaxePage';
import RelatorioHalliburtonPage from '../../pages/relatorios/relatorioHalliburton/relatorioHalliburtonPage';
import RelatorioLaPage from '../../pages/relatorios/relatorioLa/relatorioLaPage';
import RelatoriosPage from '../../pages/relatorios/relatoriosPage';
import FinanceiroRelatoriosPage from '../../pages/financeiro/financeiroRelatoriosPage';
import ExportacaoRelatoriosPage from '../../pages/exportacao/exportacaoRelatoriosPage';
import MapaProcessosPage from '../../pages/relatorios/mapaProcessos/mapaProcessosPage';
import ProcessosDesembaracadosPage from '../../pages/relatorios/processosDesembaracados/ProcessosDesembaracadosPage';
import CrodaEscritaPage from '../../pages/integracao/croda/escrita/crodaEscritaPage';
import CrodaPage from '../../pages/integracao/croda/CrodaPage';
import CrodaEscritaDanfePage from '../../pages/integracao/croda/escrita/danfe/crodaEscritaDanfePage';
import CrodaEscritaNotaFiscalPage from '../../pages/integracao/croda/escrita/nota-fiscal/crodaEscritaNotaFiscalPage';
import OcrPage from '../../pages/integracao/ocr/ocrPage';
import OcrExportPage from '../../pages/integracao/ocr-export/ocrExportPage';
import TriangulusPage from '../../pages/integracao/triangulus/TriangulusPage';
import TriangulusDanfePage from '../../pages/integracao/triangulus/danfe/triangulusDanfePage';
import RelatorioTransportadorasPage from '../../pages/relatorios/relatorioTransportadoras/relatorioTransportadorasPage';
import CrawlersPage from '../../pages/integracao/crawlers/CrawlersPage';
import CrawlersLiPage from '../../pages/integracao/crawlers/li/crawlersLiPage';
import RedBullPage from '../../pages/relatorios/relatorioRedBull/RedBullPage';
import RedBullLatasPage from '../../pages/relatorios/relatorioRedBull/latas/redBullLatasPage';
import RedBullRelatorioPadraoPage from '../../pages/relatorios/relatorioRedBull/relatorio-padrao/redBullLatasPage';
import RelatorioGerencialPage from '../../pages/relatorios/relatorioGerencial/relatorioGerencialPage';
import RelatorioProcessosPage from '../../pages/relatorios/relatorioProcessos/relatorioProcessosPage';
import RelatorioDashboardPage from '../../pages/relatorios/relatorioDashboard/relatorioDashboardPage';
import RochePage from '../../pages/integracao/roche/RochePage';
import RocheEscritaPage from '../../pages/integracao/roche/escrita/rocheEscritaPage';
import RocheEscritaDanfePage from '../../pages/integracao/roche/escrita/danfe/rocheEscritaDanfePage';
import CatalogoProdutosPlanilhaPage from '../../pages/integracao/planilhas/catalogoProdutos/CatalogoProdutosPlanilhaPage';
import ThermoFisherLeituraPage from '../../pages/integracao/thermo-fisher/leitura/ThermoFisherLeituraPage';
import ThermoFisherPage from '../../pages/integracao/thermo-fisher/ThermoFisherPage';
import ThermoFisherEscritaPage from '../../pages/integracao/thermo-fisher/escrita/ThermoFisherEscritaPage';
import DashboardSgtPage from '../../pages/relatorios/dashboardSgt/dashboardSgtPage';
import ContaAzulPage from '../../pages/relatorios/contaAzul/ContaAzulPage';
import FaturasDiorPlanilhaPage from '../../pages/integracao/faturasDior/FaturasDiorPlanilhaPage';
import SapMtnEscritaPage from '../../pages/integracao/sap-mtn/escrita/SapMtnEscritaPage';
import SapMtnDiPage from '../../pages/integracao/sap-mtn/escrita/di/SapMtnDiPage';
import SapMtnPage from '../../pages/integracao/sap-mtn/SapMtnPage';
import SapMtnDiLeituraPage from '../../pages/integracao/sap-mtn/leitura/di/SapMtnDiLeituraPage';
import SapMtnLeituraPage from '../../pages/integracao/sap-mtn/leitura/SapMtnLeituraPage';
import DiorPage from '../../pages/integracao/faturasDior/DiorPage';
import ContabilSistemaUnicoPage from '../../pages/integracao/contabil-sistema-unico/ContabilSistemaUnicoPage';
import ContabilDominioPage from '../../pages/integracao/contabil-dominio/ContabilDominioPage';
import ProformaPackingListSaidaPage from '../../pages/integracao/proforma-packing-list-saida/ProformaPackingListSaidaPage';
import ImportacaoRelatoriosPage from '../../pages/importacao/importacaoRelatoriosPage';
import EmixPage from '../../pages/integracao/emix/EmixPage';
import RelatorioDraftDanfeDachserPage from '../../pages/relatorios/relatorioDraftDanfeDachser/relatorioDraftDanfeDachserPage';
import TsTechPage from '../../pages/integracao/ts-tech/TsTechPage';
import TsTechDraftDanfePage from '../../pages/integracao/ts-tech/danfe/TsTechDraftDanfe';
import TsTechRomaneioDiPage from '../../pages/integracao/ts-tech/romaneio/TsTechRomaneioDi';
import TsTechSaidaEdiPage from '../../pages/integracao/ts-tech/edi/TsTechSaidaEdi';
import TsTechRelatoriosPage from '../../pages/integracao/ts-tech/relatorios/TsTechRelatorios';
import RolexPage from '../../pages/integracao/rolex/RolexPage';
import RolexEdi from '../../pages/integracao/rolex/RolexEdi';
import RolexCorrespondenciaPage from '../../pages/integracao/rolex/rolexCorrespondenciaPage';
import RolexCorrespondenciaDetailsPage from '../../pages/integracao/rolex/rolexCorrespondenciaDetailsPage';
import SolicitacaoPagamentoPlanilhaPage from '../../pages/integracao/planilhas/solicitacaoPagamento/solicitacaoPagamentoPlanilhasPage';
import PradaPage from '../../pages/integracao/prada/PradaPage';
import PradaItensPage from '../../pages/integracao/prada/PradaItensPage';
import PradaCusteioPage from '../../pages/integracao/prada/PradaCusteioPage';
import MartinsLogPage from '../../pages/integracao/martins-log/MartinsLogPage';
import MartinsLogEdiPage from '../../pages/integracao/martins-log/MartinsLogEdiPage';
import MartinsLogBrookerFeedPage from '../../pages/integracao/martins-log/MartinsLogBrookerFeedPage';
import MartinsLogExportPage from '../../pages/integracao/martins-log/MartinsLogExportPage';
import MartinsLogImportPage from '../../pages/integracao/martins-log/MartinsLogImportPage';
import MartinsLogEdiSaidaPage from '../../pages/integracao/martins-log/MartinsLogEdiSaidaPage';
import FollowUpListManagerPage from '../../../pages/module/import/follow-up/FollowUpListManagerPage/FollowUpListManagerPage';

type Route = {
  path: string;
  component: React.FC;
};

const tsRoutes: Route[] = [
  {
    path: '/comercial',
    component: ComercialPage,
  },
  {
    path: '/comercial/propostas',
    component: PropostasPage,
  },
  {
    path: '/comercial/propostas/nova',
    component: PropostasNewPage,
  },
  {
    path: '/comercial/propostas/indices',
    component: PropostasIndices,
  },
  {
    path: '/comercial/propostas/mercadorias',
    component: PropostasMercadorias,
  },
  {
    path: '/comercial/propostas/servicos',
    component: PropostasServicos,
  },
  {
    path: '/comercial/propostas/cadastros',
    component: PropostasCadastros,
  },
  {
    path: '/comercial/propostas/:id',
    component: PropostasDetails,
  },
  {
    path: '/comercial/propostas/:id/follow-ups',
    component: PropostasFollowUpPage,
  },
  {
    path: '/assessoria',
    component: AssessoriaPage,
  },
  {
    path: '/assessoria/followup',
    component: AssessoriaFollowupPage,
  },
  {
    path: '/assessoria/followup/novo',
    component: NewAssessoriaFollowupPage,
  },
  {
    path: '/assessoria/followup/:id/detalhes',
    component: ViewAssessoriaFollowupPage,
  },
  {
    path: '/assessoria/followup/:id/timeline',
    component: FollowUpAssessoriaTimelineManagerPage,
  },
  // {
  //   path: '/assessoria/followup/:id/lista',
  //   component: FollowUpListManagerPage,
  // },
  {
    path: '/integracao',
    component: IntegracaoPage,
  },
  {
    path: '/integracao/contabil-sistema-unico',
    component: ContabilSistemaUnicoPage,
  },
  {
    path: '/integracao/contabil-dominio',
    component: ContabilDominioPage,
  },
  {
    path: '/integracao/proforma-packing-list-saida',
    component: ProformaPackingListSaidaPage,
  },
  {
    path: '/integracao/planilhas',
    component: PlanilhasPage,
  },
  {
    path: '/integracao/planilhas/faturas',
    component: FaturasPlanilhasPage,
  },
  {
    path: '/integracao/planilhas/empresas-estrangeiras',
    component: EmpresasEstrangeirasPlanilhasPage,
  },
  {
    path: '/integracao/planilhas/solicitacao-pagamento',
    component: SolicitacaoPagamentoPlanilhaPage,
  },
  {
    path: '/integracao/planilhas/catalogo',
    component: CatalogoProdutosPlanilhaPage,
  },
  {
    path: '/integracao/dior/faturas',
    component: FaturasDiorPlanilhaPage,
  },
  {
    path: '/integracao/dior',
    component: DiorPage,
  },
  {
    path: '/integracao/emix',
    component: EmixPage,
  },
  {
    path: '/integracao/planilhas/faturas/dior',
    component: FaturasDiorPlanilhaPage,
  },
  {
    path: '/integracao/totvs-easy',
    component: TotuvseasyPage,
  },
  {
    path: '/integracao/totvs-easy/leitura',
    component: TotvsLeituraPage,
  },
  {
    path: '/integracao/totvs-easy/correspondencia',
    component: TotvsCorrespondenciaPage,
  },
  {
    path: '/integracao/totvs-easy/correspondencia/:id',
    component: TotvsCorrespondenciaDetailsPage,
  },
  {
    path: '/integracao/totvs-easy/escrita',
    component: TotvsEscritaPage,
  },
  {
    path: '/integracao/totvs-easy/escrita/despesas',
    component: TotvsEscritaDespesasPage,
  },
  {
    path: '/integracao/totvs-easy/escrita/danfe',
    component: TotvsEscritaDanfePage,
  },
  {
    path: '/integracao/totvs-easy/escrita/numerarios',
    component: TotvsEscritaNumerariosPage,
  },
  {
    path: '/integracao/triangulus',
    component: TriangulusPage,
  },
  {
    path: '/integracao/triangulus/danfe',
    component: TriangulusDanfePage,
  },
  {
    path: '/integracao/croda',
    component: CrodaPage,
  },
  {
    path: '/integracao/croda/escrita',
    component: CrodaEscritaPage,
  },
  {
    path: '/integracao/croda/escrita/danfe',
    component: CrodaEscritaDanfePage,
  },
  {
    path: '/integracao/croda/escrita/nota-fiscal',
    component: CrodaEscritaNotaFiscalPage,
  },
  {
    path: '/integracao/ocr',
    component: OcrPage,
  },
  {
    path: '/integracao/ocr-export',
    component: OcrExportPage,
  },
  {
    path: '/integracao/crawlers',
    component: CrawlersPage,
  },

  {
    path: '/integracao/crawlers/li',
    component: CrawlersLiPage,
  },
  {
    path: '/integracao/sapmtn',
    component: SapMtnPage,
  },
  {
    path: '/integracao/sapmtn/escrita',
    component: SapMtnEscritaPage,
  },
  {
    path: '/integracao/sapmtn/escrita/di',
    component: SapMtnDiPage,
  },
  {
    path: '/integracao/sapmtn/leitura',
    component: SapMtnLeituraPage,
  },
  {
    path: '/integracao/sapmtn/leitura/di',
    component: SapMtnDiLeituraPage,
  },
  {
    path: '/relatorios',
    component: RelatoriosPage,
  },
  {
    path: '/financeiro/relatorios',
    component: FinanceiroRelatoriosPage,
  },
  {
    path: '/exportacao/relatorios',
    component: ExportacaoRelatoriosPage,
  },
  {
    path: '/importacao/relatorios',
    component: ImportacaoRelatoriosPage,
  },
  {
    path: '/relatorios/mapa-processos',
    component: MapaProcessosPage,
  },
  {
    path: '/relatorios/processos-desembaracados',
    component: ProcessosDesembaracadosPage,
  },
  {
    path: '/relatorios/halliburton',
    component: RelatorioHalliburtonPage,
  },
  {
    path: '/relatorios/danfe',
    component: RelatorioDraftDanfePage,
  },
  {
    path: '/relatorios/danfeFaxe',
    component: RelatorioDraftDanfeFaxePage,
  },
  {
    path: '/relatorios/laNova',
    component: RelatorioDraftDanfeDachserPage,
  },
  {
    path: '/relatorios/la',
    component: RelatorioLaPage,
  },
  {
    path: '/relatorios/associated',
    component: RelatorioAssociatedPage,
  },
  {
    path: '/relatorios/transportadoras',
    component: RelatorioTransportadorasPage,
  },
  {
    path: '/relatorios/redbull',
    component: RedBullPage,
  },
  {
    path: '/relatorios/redbull/latas',
    component: RedBullLatasPage,
  },
  {
    path: '/relatorios/redbull/comum',
    component: RedBullRelatorioPadraoPage,
  },
  {
    path: '/relatorios/gerencial',
    component: RelatorioGerencialPage,
  },
  {
    path: '/relatorios/processos',
    component: RelatorioProcessosPage,
  },
  {
    path: '/relatorios/dashboard',
    component: RelatorioDashboardPage,
  },
  {
    path: '/relatorios/dashboard-sgt',
    component: DashboardSgtPage,
  },
  {
    path: '/relatorios/conta-azul',
    component: ContaAzulPage
  },
  {
    path: '/integracao/roche',
    component: RochePage,
  },
  {
    path: '/integracao/roche/escrita',
    component: RocheEscritaPage,
  },
  {
    path: '/integracao/roche/escrita/danfe',
    component: RocheEscritaDanfePage,
  },
  {
    path: '/integracao/thermo-fisher/leitura',
    component: ThermoFisherLeituraPage,
  },
  {
    path: '/integracao/thermo-fisher/escrita',
    component: ThermoFisherEscritaPage,
  },
  {
    path: '/integracao/thermo-fisher',
    component: ThermoFisherPage,
  },
  {
    path: '/integracao/ts-tech',
    component: TsTechPage,
  },
  {
    path: '/integracao/ts-tech/danfe',
    component: TsTechDraftDanfePage,
  },
  {
    path: '/integracao/ts-tech/romaneio',
    component: TsTechRomaneioDiPage,
  },
  {
    path: '/integracao/ts-tech/edi',
    component: TsTechSaidaEdiPage,
  },
  {
    path: '/integracao/ts-tech/relatorios',
    component: TsTechRelatoriosPage,
  },
  {
    path: '/integracao/rolex',
    component: RolexPage,
  },
  {
    path: '/integracao/rolex/edi',
    component: RolexEdi,
  },
  {
    path: '/integracao/rolex/correspondencias',
    component: RolexCorrespondenciaPage,
  },
  {
    path: '/integracao/rolex/correspondencias/:id',
    component: RolexCorrespondenciaDetailsPage,
  },
  {
    path: '/integracao/prada',
    component: PradaPage,
  },
  {
    path: '/integracao/prada/itens',
    component: PradaItensPage,
  },
  {
    path: '/integracao/prada/custeio',
    component: PradaCusteioPage,
  },
  {
    path: '/integracao/apple',
    component: MartinsLogPage,
  },
  {
    path: '/integracao/apple/edi',
    component: MartinsLogEdiPage,
  },
  {
    path: '/integracao/apple/saidaEdi',
    component: MartinsLogEdiSaidaPage,
  },
  {
    path: '/integracao/apple/brookerFeed',
    component: MartinsLogBrookerFeedPage,
  },
  {
    path: '/integracao/apple/importReport',
    component: MartinsLogImportPage,
  },
  {
    path: '/integracao/apple/exportReport',
    component: MartinsLogExportPage,
  },
];

export { tsRoutes };
